import { render, staticRenderFns } from "./PorletOpenDrawerLeft.vue?vue&type=template&id=208a9745&"
import script from "./PorletOpenDrawerLeft.vue?vue&type=script&lang=js&"
export * from "./PorletOpenDrawerLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports